import styled from 'styled-components'

export const Section = styled.section`
  padding: 10rem 0 14rem;
  margin-bottom: 16rem;
  background: linear-gradient(90deg, #e1e8fe 12.01%, #ebeffe 96.25%);

  @media (max-width: 1279px) {
    margin-bottom: 14rem;
  }

  @media (max-width: 999px) {
    padding-bottom: 10rem;
  }

  @media (max-width: 767px) {
    margin-bottom: 12rem;
  }
`

export const Row = styled.div`
  display: flex;
  gap: 2rem;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 3rem;
  }
`

export const Wrapper = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
`

export const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin: 2rem 0 0;

  @media (max-width: 767px) {
    margin: 1.5rem 0 0;
  }
`

export const Tooltip = styled.div`
  position: relative;
  top: 3px;
`
